import { render } from "./PuzzleLadderView.vue?vue&type=template&id=ba23faa6&scoped=true"
import script from "./PuzzleLadderView.vue?vue&type=script&lang=js"
export * from "./PuzzleLadderView.vue?vue&type=script&lang=js"

import "./PuzzleLadderView.vue?vue&type=style&index=0&id=ba23faa6&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba23faa6"]])

export default __exports__